import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { DATA } from '../data/urunler-data';

import LinkComponent from '../components/LinkComponent';

import "yet-another-react-lightbox/styles.css";
import InnerSystemComponent from '../components/InnerSystemComponent';

const IcSistemler = () => {

    const { id1, id2 } = useParams();


    const category = DATA.find(category => category.link === id1);

    const innerCategory = category.innerCategory.find(innerCategory => innerCategory.link === id2);



    if (!category) {
        return <div>Bu kategoride sistem bulunamadı.</div>;
    }








    return (
        <div className='flex flex-col'>
            <LinkComponent />
            <InnerSystemComponent category={category} data={innerCategory} id1={id1}  id2={id2}/>


            {/* <div className='grid grid-cols-14 bg-white'>
            <div className='col-start-2 col-span-11 h-96 bg-amber-300' >
            <div className='text-xs font-extralight mb-5 mt-20'>PROJELER</div>



                </div>

                
                </div> */}
        </div>
    );
};

export default IcSistemler;
